import { RemoveSymbolsByMaskActionHandler } from "@slot/client-engine";
import type { GridPresenter, MechanicPlugin } from "@slot/mechanics-core";
import { HoldCellsActionHandler } from "./HoldCellsActionHandler";
import type { HoldGridPresenter } from "./HoldGridPresenter";

/**
 * Hold and win as a mechanic plugin (decision 50): the frame presenter prepares through the hold adapter and reveals
 * through the composite grid presenter (the cells roll and land; the effect layers draw on the same event), and the
 * plugin's one action is `hold_cells`, which tells the next frame what stays. Hold and win removes nothing, but the
 * mask handler delegates to the composite like the reels', so the contract holds without special-casing. The cells
 * brake their own rolls under a private scope (`HoldSpinMechanic.requestSlamStop`, through `GamePresentation.slam`),
 * so no slam scope.
 */
export function buildHoldReplayPlugin(input: {
  gridPresenter: GridPresenter;
  basePresenter: HoldGridPresenter;
  /** The grid's cell count (columns × rows): the length every `hold_cells` mask must have. */
  cellCount: number;
}): MechanicPlugin {
  const { gridPresenter, basePresenter } = input;
  return {
    framePresenter: {
      prepareEventFrame: (event) => basePresenter.prepareEventFrame(event),
      revealEventFrame: (event) => gridPresenter.presentEventFrame(event),
    },
    plugin: {
      name: "hold",
      actionHandlers: [
        new HoldCellsActionHandler(basePresenter, input.cellCount),
        new RemoveSymbolsByMaskActionHandler((positionMask) => gridPresenter.removeSymbolsByMask(positionMask)),
      ],
    },
    slamScopes: { presentation: [] },
  };
}
